package com.dotdrives.web.pages.onboarding

import com.dotdrives.controller.OnboardingUiState
import com.dotdrives.web.ui.DotBanner
import com.dotdrives.web.ui.DotButton
import com.dotdrives.web.ui.DotTextField
import react.FC
import react.Props
import react.dom.html.ReactHTML.div
import react.dom.html.ReactHTML.form
import react.dom.html.ReactHTML.h1
import react.dom.html.ReactHTML.p
import web.cssom.ClassName

external interface ProfileStepProps : Props {
    var state: OnboardingUiState
    var email: String
    var onProfileChange: (String, String, String) -> Unit
    var onContinue: () -> Unit
}

val ProfileStep = FC<ProfileStepProps> { props ->
    val state = props.state

    form {
        className = ClassName("onboarding-step-form")
        onSubmit = { event ->
            event.preventDefault()
            props.onContinue()
        }

        div {
            className = ClassName("onboarding-step-meta dot-meta")
            +"STEP 1 OF 4"
        }
        h1 {
            className = ClassName("onboarding-step-title dot-heading")
            +"Tell us who you are"
        }
        p {
            className = ClassName("onboarding-step-copy")
            +"Signed in as ${props.email} ✓"
        }

        state.error?.let { message ->
            DotBanner {
                this.message = message
            }
        }

        div {
            className = ClassName("onboarding-profile-grid")
            DotTextField {
                value = state.firstName
                onValueChange = { props.onProfileChange(it, state.lastName, state.phone) }
                label = "First name *"
                placeholder = "First name"
            }
            DotTextField {
                value = state.lastName
                onValueChange = { props.onProfileChange(state.firstName, it, state.phone) }
                label = "Last name *"
                placeholder = "Last name"
            }
        }
        DotTextField {
            value = state.phone
            onValueChange = { props.onProfileChange(state.firstName, state.lastName, it) }
            label = "Phone *"
            placeholder = "(555) 555-0100"
        }

        DotButton {
            text = "Continue →"
            onClick = props.onContinue
            loading = state.loading
            enabled = state.canSubmitProfile
            className = "dot-full-width"
        }
    }
}
